<template>
    <group-type-table template-type="client"></group-type-table>
</template>

<script>
    const groupTypeTable =() => import ('@/components/orgApps/GroupType/GroupTypeTable');

    export default {
        name: "dashboard",
        components: {
            groupTypeTable
        },
        data(){
            return {};
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>